export const fieldNames = {
  typeId: 'typeId',
  serialNumber: 'serialNumber',
  model: 'model',
  mark: 'mark',
  installDate: 'installDate',
  commissioningDate: 'commissioningDate',
  actFile: 'actFile',
  files: 'files',
  verificationDate: 'verificationDate',
  statusId: 'statusId',
  sealNumber: 'sealNumber',
  verificationInterval: 'verificationInterval',
  nextVerificationDate: 'nextVerificationDate',
  locationId: 'locationId',
  tariffCount: 'tariffCount',
};

export const METER_TEXT_FIELD_LIMIT = 64;
export const TOOLTIP_TITLE =
  'Для редактирования данных измените статус счетчика';
export const baseQueryOptions = { staleTime: Infinity };
